import { HubConnection } from "@modules/@microsoft/signalr/dist/esm";
import { IMoneyFormatterService } from "../services/IMoneyFormatterService";
import { SinglegameApi } from "./singlegame_api_extended";
import { TranslationService } from "../services/TranslationService";
import { FountainPIXI } from "../multigame/slot/FountainAnimationPIXI";
import { IOManagerService } from "../services/IOManagerService";
import { ResourceIdentifier } from "../multigame/ResourceManager/ResourceIdentifier";
import { AudioManager } from "../multigame/AudioManager";
import { SpeedManager } from "../multigame/SpeedManager";
import { SharedTransitionContainer } from "../multigame/Context/SharedTransitionContext";
import { SharedVideoContainer } from "../multigame/Context/SharedVideoContext";
import { ResourceManager } from "../multigame/ResourceManager/ResourceManager";
import { ServiceProvider } from "./SinglegameServices";
import { ISystemContext } from "../multigame/Context/SystemContext";
import { IBackendSettingsService } from "../services/BackendSettingsService";
import { Singlegame_PIXIAPP } from "./Singlegame_PIXIAPP";
import { LogGroup } from "../multigame/MyHelpers";
import { GameEngineResponsive } from "../multigame/engine/GameEngineResponsive";


export type SinglegameServiceMap =
{
    "MoneyFormatter": IMoneyFormatterService,
    "HubConnection": HubConnection,
    "SinglegameApi": SinglegameApi,
    "TranslationService": TranslationService,
    "IOManagerService": IOManagerService,
    "FountainPIXI": FountainPIXI,
    "ResourceIdentifier": ResourceIdentifier,
    "LogGroup": LogGroup,
    "AudioManager": AudioManager,
    "SpeedManager": SpeedManager,
    "SharedVideoContainer": SharedVideoContainer,
    "SharedTransitionContainer": SharedTransitionContainer,
    "ResourceManager": ResourceManager,
    "SystemContext": ISystemContext
    "GameEngineResponsive": GameEngineResponsive,
    "BackendSettings": IBackendSettingsService,
    "Singlegame": Singlegame_PIXIAPP,
}


export const serviceProvider = new ServiceProvider<SinglegameServiceMap>();